import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  height: 300px;
  width: 100%;
  display: grid;
  place-content: center;
  background-color: #f6f8fa;
  border-radius: 5px;
  margin-block: 20px;
  text-align: center;
`;

const EmptyState = () => {
  return (
    <StyledDiv>
      <p className="fw-bold">OOPS !!!</p>
      <p>No record found for this category !!!</p>
    </StyledDiv>
  );
};

export default EmptyState;
